module.exports = __webpack_public_path__ + "img/download_header_red.b7deb622.png";